<template>
  <div v-if="filterListBulk && facet.name" class="card" :class="facet.cssClass">
    <div v-if="facet.type === 'price'">
      <item-filter-price />
    </div>
    <div v-else class="accordion-wrapper">
      <button
          class="filter-btn text-left"
          type="button"
          @click="toggleAccordion"

      >
        <span v-html="facetName"></span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.182"
            height="8"
            viewBox="0 0 13.182 8"
            :class="['arrDown', { rotate180: isOpen }]"
        >
          <path
              id="chevron-down-solid"
              d="M11.735,131.282l-5.867-5.867a.724.724,0,0,1,0-1.025l.684-.684a.724.724,0,0,1,1.023,0l4.671,4.649,4.671-4.649a.724.724,0,0,1,1.023,0l.684.684a.724.724,0,0,1,0,1.025l-5.867,5.867A.725.725,0,0,1,11.735,131.282Z"
              transform="translate(-5.656 -123.494)"
              fill="#464646"
          />
        </svg>
      </button>

      <ul v-show="isOpen" class="accordion-list w-100 mt-0">
        <li
            v-for="value in facets"
            :key="value.id"
            :class="['dropdown-item ' + value.cssClass, { disabled: value.count <= 0 }]"
        >
          <div class="form-check p-0 m-0">
            <input
                :id="'option-' + value.id + '-' + _uid"
                :ref="'facetCheckbox-' + value.id"
                class="form-check-input d-none"
                type="checkbox"
                :checked="isSelected(value.id)"
                @change="updateFacet(value)"
                :disabled="isLoading || value.count <= 0"
            />
            <label
                :for="'option-' + value.id + '-' + _uid"
                class="form-check-label"
                :class="facet.id === 'feedback' ? 'option-' + value.id : ''"
            >
              <span v-html="value.name"></span>
            </label>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div v-else-if="facet.name" class="card" :class="facet.cssClass">
    <div v-if="facet.type === 'price'">
      <item-filter-price />
    </div>
    <div v-else class="dropdown">
      <button
          class="filter-btn dropdown-toggle w-100 text-left"
          type="button"
          :id="'dropdown-' + _uid"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
      >
        <span v-html="facetName"></span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.182"
            height="8"
            viewBox="0 0 13.182 8"
            class="arrDown"
        >
          <path
              id="chevron-down-solid"
              d="M11.735,131.282l-5.867-5.867a.724.724,0,0,1,0-1.025l.684-.684a.724.724,0,0,1,1.023,0l4.671,4.649,4.671-4.649a.724.724,0,0,1,1.023,0l.684.684a.724.724,0,0,1,0,1.025l-5.867,5.867A.725.725,0,0,1,11.735,131.282Z"
              transform="translate(-5.656 -123.494)"
              fill="#464646"
          />
        </svg>
      </button>

      <ul class="dropdown-menu w-100" :aria-labelledby="'dropdown-' + _uid">
        <li
            v-for="value in facets"
            :key="value.id"
            :class="['dropdown-item ' + value.cssClass, { disabled: value.count <= 0 }]"
        >
          <div class="form-check m-0">
            <input
                :id="'option-' + value.id + '-' + _uid"
                :ref="'facetCheckbox-' + value.id"
                class="form-check-input d-none"
                type="checkbox"
                :checked="isSelected(value.id)"
                @change="updateFacet(value)"
                :disabled="isLoading || value.count <= 0"
            />
            <label
                :for="'option-' + value.id + '-' + _uid"
                class="form-check-label"
                :class="facet.id === 'feedback' ? 'option-' + value.id : ''"
            >
              <span v-html="value.name"></span>
              <span v-if="showBadges" class="badge badge-secondary">{{ value.count }}</span>
            </label>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ItemFilterPrice from "./ItemFilterPrice.vue";

export default {
  name: "item-filter",

  components: {
    ItemFilterPrice,
  },

  props: {
    showBadges: Boolean,
    filterListBulk: Boolean,
    facet: {
      type: Object,
    },
    paddingClasses: {
      type: String,
      default: null,
    },
    paddingInlineStyles: {
      type: String,
      default: null,
    },
    activeFacetId: [String, Number],
  },

  data() {
    return {
      dropdownOpen: false,
    };
  },

  computed: {
    facets() {
      return this.facet.values;
    },

    facetName() {
      if (this.facet.translationKey && this.facet.translationKey.length > 0) {
        return this.$translate("Ceres::Template." + this.facet.translationKey);
      }
      return this.facet.name;
    },

    ...mapState({
      selectedFacets: state => state.itemList.selectedFacets,
      isLoading: state => state.itemList.isLoading,
    }),

    isOpen() {
      return this.facet.id === this.activeFacetId;
    }
  },

  methods: {
    updateFacet(facetValue) {
      const toolbarElements = document.getElementsByClassName("widget-toolbar");

      const inputRefName = 'facetCheckbox-' + facetValue.id;
      const inputElement = this.$refs[inputRefName];

      if (inputElement && toolbarElements.length > 0) {
        const inputParentToolbar = Array.from(toolbarElements).find(toolbarElement =>
            toolbarElement.contains(inputElement)
        );

        if (inputParentToolbar) {
          window.localStorage.setItem("openFilterToolbar", true);
        }
      }
      this.$store.dispatch("selectFacet", { facetValue });
    }
,

    isSelected(facetValueId) {
      return this.selectedFacets.findIndex(selectedFacet => selectedFacet.id === facetValueId) > -1;
    },

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    toggleAccordion() {
      const newId = this.isOpen ? null : this.facet.id;
      this.$emit("toggle-accordion", newId);
    }
  },
};
</script>
